import { Grid, Stack, Typography } from 'src/components/mui';
//@ts-ignore
import React from 'react';
import KeyAsset from './components/KeyAsset';
import MouseAsset from './components/MouseAsset';

type Props = {
  translation?: any;
};

export default function Navigation({ translation: t }: Props) {
  return (
    <Grid container spacing={{ xs: 6, sm: 4 }}>
      <Grid item xs={12} sm={4}>
        <Stack spacing={2} textAlign="center">
          <Typography>{t?.helpMouseDrag || 'Click and Drag to look around the Space'}</Typography>
          <MouseAsset secondary="fa-rotate-left" />
          <Typography>
            {t?.helpMouseDragOr || 'Use the arrow keys to turn left and right'}
          </Typography>
          <KeyAsset first="fa-square-arrow-left" second="fa-square-arrow-right" />
        </Stack>
      </Grid>
      <Grid item xs={12} sm={4}>
        <Stack spacing={2} textAlign="center">
          <Typography>
            {t?.helpMouseAround || 'Click on the rings throughout the space to move around'}
          </Typography>
          <MouseAsset secondary="fa-circle" />
          <Typography>
            {t?.helpMouseAroundOr || 'Use the arrow keys to move forward and back'}
          </Typography>
          <KeyAsset first="fa-square-arrow-up" second="fa-square-arrow-down" direction="column" />
        </Stack>
      </Grid>
      <Grid item xs={12} sm={4}>
        <Stack spacing={2} textAlign="center">
          <Typography>{t?.helpMouseWheel || 'Use the scroll wheel to zoom in and out'}</Typography>
          <MouseAsset secondary="fa-magnifying-glass-plus" />
          <Typography>
            {t?.helpMouseWheelOr || 'Use the plus and minus keys to zoom in and out'}
          </Typography>
          <KeyAsset first="fa-square-plus" second="fa-square-minus" />
        </Stack>
      </Grid>
    </Grid>
  );
}
